module.exports = __webpack_public_path__ + "img/card-b-dim.f4f91508.png";